<footer class="footer">
  <div class="container">

    <p class="text-muted text-center" style="font-size: 15px; color: #0088f2;">
      <a href="tel: 866-536-3459">Contact Us (866) 536-3459</a>
    </p>
    <p class="text-muted text-center" style="font-size: 13px; margin-bottom: 10px !important;">
      <a href="https://www.lendingman.com/terms-of-use">Terms of Use</a> | <a href="https://www.lendingman.com/privacy-policy">Privacy Policy</a> | <a href="https://www.lendingman.com/disclosures-licenses">Licenses & Disclosures</a>
    </p>
    <p class="text-muted text-center" style="font-size: 10px;">
      © 2020 ResMac, Inc., dba LendingMan
    </p>
  </div>
</footer>

